module.exports = __webpack_public_path__ + "static/media/check.cf0eb63d.svg";